<template>
  <div class="modal-add-location">
    <SimpleModal>
      <img
        class="modal-add-location__image"
        src="../../assets/img/OA_logo.svg"
        alt=""
      />
      <div class="modal-add-location__p">
        Actuele informatie over omgevingsvergunningen
      </div>
      <div class="modal-add-location__button" @click="openSideBarLocations">
        Voeg jouw locatie toe
        <svg class="modal-add-location__button__icon" svg-inline="" focusable="false" role="presentation" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path id="a" d="M0 0h24v24H0z"/></defs><g fill="none" fill-rule="evenodd"><mask id="b" fill="#fff"><use xlink:href="#a"/></mask><path fill="#101010" mask="url(#b)" d="M11 4h2v16h-2z"/><path fill="#101010" mask="url(#b)" transform="rotate(90 12 12)" d="M11 4h2v16h-2z"/></g></svg>
      </div>
    </SimpleModal>
  </div>
</template>

<script>
import SimpleModal from "@/components/SimpleModal.vue";

export default {
  components: {
    SimpleModal
  },
  methods: {
    openSideBarLocations() {
      this.$store.commit("closeModalAddLocation");
      this.$store.commit("openSidebarMunicipalitiesIndex");
    }
  }
};
</script>

<style scoped lang="scss">
.modal-add-location {
  &__image {
  }
  &__p {
    @extend %text-small;
    max-width: 280px;
    margin: $spacing-4 auto;
  }
  &__button {
    @extend %text-small;
    color: #fff;
    height: 48px;
    border-radius: 8px;
    background-color: $color-green-1;
    padding: 0 $spacing-4;
    line-height: 48px;
    display: inline-block;
    cursor: pointer;
    transition: background-color $easing-1;

    &:hover {
      background-color: darken($color-green-1, 5%);
    }

    &__icon {
      position: relative;
      top: 7px;
      padding-left: 5px;
      width: 24px;
      height: 24px;

      path {
        fill: #fff;
      }
    }
  }
}
</style>
